module.exports = __webpack_public_path__ + "static/media/conf-app7.5c47016a.png";